import DashboardPage from "../pages/DashboardPage";
import Usermangement from "../pages/Users/Usermangement";
import Sellermanagement from "../pages/Seller/Sellermanagement";
import SellerRegisterPage from "../pages/Seller/SellerRegisterPage";
import Ordermanagement from "../pages/Order/Ordermanagement";
import Productmanagement from "../pages/Product/Productmanagement";
import AddProduct from "../pages/Product/AddProduct";
import EditProduct from "../pages/Product/EditProduct";
import ViewProduct from "../pages/Product/ViewProduct";
import Customermanagement from "../pages/Customer/Customermanagement";
import Categories from "../pages/Category/Categories";
import CategoryCluster from "../pages/Category/CategoryCluster";
import Profile from "../pages/Profile/Profile";
import Inventorymanagement from "../pages/Inventorymanagement";
import Warehouse from "../pages/Warehouse/Warehouse";
import MobileContent from "../pages/MobileContent/MobileContent";
import ActivityLog from "../pages/Logs/ActivityLog";
import LoginLogs from "../pages/Logs/LoginLogs";
import LoginPage from "../pages/Login/LoginPage";
import Layout from "../components/Layout";
import Couponsmanagement from "../pages/Coupons/Couponsmanagement";
import ProductRequestList from "../pages/ProductRequestList";
import Settings from "../pages/Settings/Settings";
import Rewards from "../pages/Rewards/Rewards";
import AppPolicy from "../pages/AppPolicy/AppPolicy";
import FAQs from "../pages/FAQs/FAQs";
import Email from "../pages/Campaign/Email/Email";
import Sms from "../pages/Campaign/Sms/Sms";
import Whatsapp from "../pages/Campaign/Whatsapp/Whatsapp";
import Notification from "../pages/Notification/Notification";
import EmailDetails from "../pages/Campaign/Email/EmailDetails";
import Queries from "../pages/Queries/Queries";
import Chat from "../pages/Queries/Chat";
import Expired from "../pages/Expired/Expired";
import VariationGroups from "../pages/VariationGroups/VariationGroups";
import Supplier from "../pages/Supplier/Supplier";
import ShippingPaymentConfig from "../pages/Shipping & Payment Config/Shipping&PaymentConfig";
import SellerPayout from "../pages/SellerPayout/SellerPayout";
import SupplierPayout from "../pages/SupplierPayout/SupplierPayout";
import RoleManagement from "../pages/Users/RoleManagement"; // Added import
import GenericReportPage from "../pages/Reports/GenericReportPage";
import SalesRevenueReport from "../pages/Reports/SalesRevenueReport";
import OrderReport from "../pages/Reports/OrderReport";
import InvoiceReport from "../pages/Reports/InvoiceReport";
import GstSummaryReport from "../pages/Reports/GstSummaryReport";
import ProductSalesReport from "../pages/Reports/ProductSalesReport";
import CategoryReport from "../pages/Reports/CategoryReport";
import BrandReport from "../pages/Reports/BrandReport";
import ProfitLossReport from "../pages/Reports/ProfitLossReport";
import ReturnReport from "../pages/Reports/ReturnReport";
import RatingsReport from "../pages/Reports/RatingsReport";
import SellerSalesReport from "../pages/Reports/SellerSalesReport";
import SellerSettlementReport from "../pages/Reports/SellerSettlementReport";
import SupplierPurchaseReport from "../pages/Reports/SupplierPurchaseReport";
import SupplierLedgerReport from "../pages/Reports/SupplierLedgerReport";
import InventoryReport from "../pages/Reports/InventoryReport";
import PaymentReport from "../pages/Reports/PaymentReport";
import ShippingReport from "../pages/Reports/ShippingReport";
import CampaignReport from "../pages/Reports/CampaignReport";
import CustomerReport from "../pages/Reports/CustomerReport";
import MarketingReport from "../pages/Reports/MarketingReport";
import SupportReport from "../pages/Reports/SupportReport";
import OnlineOrders from "../pages/OnlineOrders/OnlineOrders";
import ComboOfferList from "../pages/Offers/ComboOfferList";
import CreateComboOffer from "../pages/Offers/CreateComboOffer";
import ViewComboOffer from "../pages/Offers/ViewComboOffer";
import BogoOfferList from "../pages/Offers/BogoOfferList";
import CreateBogoOffer from "../pages/Offers/CreateBogoOffer";
import ViewBogoOffer from "../pages/Offers/ViewBogoOffer";
import BrandManagement from "../pages/Brand/BrandManagement";
import React from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../components/NotFound";

import ProtectedRoute from "../components/ProtectedRoute";

import Swal from "sweetalert2";
import { postData } from "../Webservice/Webservice";

// Create a function to generate routes with onLogout injected
export function useAppRoutes() {
  const navigate = useNavigate();
  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You will be logged out of your account!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Revoke the session server-side so the token can't be replayed after logout.
        try {
          const tokenValue = sessionStorage.getItem('token');
          if (tokenValue) {
            await postData('auth/logout', {}, `Bearer ${tokenValue}`, false, true);
          }
        } catch (err) {
          console.error('Error revoking session on logout:', err);
        }

        // Clear all storage for a total reset
        sessionStorage.clear();
        localStorage.clear();

        // Redirection to the login page
        navigate("/", { replace: true });
      }
    });
  };

  const routes = [
    // Common login routes
    { path: "/", element: <LoginPage /> },
    { path: "/seller/register", element: <SellerRegisterPage /> },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout onLogout={handleLogout} />
        </ProtectedRoute>
      ),
      children: [
        { path: "dashboard", element: <DashboardPage /> },
        { path: "usermangement", element: <Usermangement /> },
        { path: "roles", element: <RoleManagement /> }, // Added route
        // HR Management is a separate project — menu click redirects to its own login
        { path: "sellermanagement", element: <Sellermanagement /> },
        { path: "sellermanagement/:sellerId", element: <Sellermanagement /> },
        { path: "ordermanagement", element: <Ordermanagement /> },
        { path: "ordermanagement/:orderId", element: <Ordermanagement /> },
        { path: "productmanagement", element: <Productmanagement /> },
        { path: "productmanagement/add", element: <AddProduct /> },
        { path: "productmanagement/edit/:productId", element: <EditProduct /> },
        { path: "productmanagement/view/:productId", element: <ViewProduct /> },
        { path: "variationgroups", element: <VariationGroups /> },
        { path: "productrequestlist", element: <ProductRequestList /> },
        { path: "customermanagement", element: <Customermanagement /> },
        { path: "categories", element: <Categories /> },
        { path: "categorycluster", element: <CategoryCluster /> },
        { path: "profile", element: <Profile /> },
        { path: "inventorymanagement", element: <Inventorymanagement /> },
        { path: "warehouse", element: <Warehouse /> },
        { path: "mobilecontent", element: <MobileContent /> },
        { path: "activitylog", element: <ActivityLog /> },
        { path: "loginlogs", element: <LoginLogs /> },
        { path: "couponsmanagement", element: <Couponsmanagement /> },
        { path: "couponsmanagement/:couponId", element: <Couponsmanagement /> },
        { path: "settings", element: <Settings /> },
        { path: "rewards", element: <Rewards /> },
        { path: "apppolicy", element: <AppPolicy /> },
        { path: "faqs", element: <FAQs /> },
        { path: "sms", element: <Sms /> },
        { path: "email", element: <Email /> },
        { path: "email/:campaignId", element: <EmailDetails /> },
        { path: "whatsapp", element: <Whatsapp /> },
        { path: "notification", element: <Notification /> },
        { path: "queries", element: <Queries /> },
        { path: "queries/chat/:queryId", element: <Chat /> },
        { path: "/expired", element: <Expired /> },
        { path: "/supplier", element: <Supplier /> },
        { path: "/shippingpaymentconfig", element: <ShippingPaymentConfig /> },
        { path: "sellerpayout", element: <SellerPayout /> },
        { path: "supplierpayout", element: <SupplierPayout /> },
        { path: "onlineorders", element: <OnlineOrders /> },
        { path: "onlineorders/:requestId", element: <OnlineOrders /> },
        { path: "offers/combo", element: <ComboOfferList /> },
        { path: "offers/combo/create", element: <CreateComboOffer /> },
        { path: "offers/combo/edit/:id", element: <CreateComboOffer /> },
        { path: "offers/combo/view/:id", element: <ViewComboOffer /> },
        { path: "offers/bogo", element: <BogoOfferList /> },
        { path: "offers/bogo/create", element: <CreateBogoOffer /> },
        { path: "offers/bogo/edit/:id", element: <CreateBogoOffer /> },
        { path: "offers/bogo/view/:id", element: <ViewBogoOffer /> },
        { path: "brands", element: <BrandManagement /> },
        { path: "reports/sales-revenue", element: <SalesRevenueReport /> },
        { path: "reports/orders", element: <OrderReport /> },
        { path: "reports/invoices", element: <InvoiceReport /> },
        { path: "reports/gst-summary", element: <GstSummaryReport /> },
        { path: "reports/product-sales", element: <ProductSalesReport /> },
        { path: "reports/category-performance", element: <CategoryReport /> },
        { path: "reports/brand-performance", element: <BrandReport /> },
        { path: "reports/profit-loss", element: <ProfitLossReport /> },
        { path: "reports/returns", element: <ReturnReport /> },
        { path: "reports/customer-ratings", element: <RatingsReport /> },
        { path: "reports/seller-sales", element: <SellerSalesReport /> },
        { path: "reports/seller-settlement", element: <SellerSettlementReport /> },
        { path: "reports/supplier-purchase", element: <SupplierPurchaseReport /> },
        { path: "reports/supplier-ledger", element: <SupplierLedgerReport /> },
        { path: "reports/inventory-report", element: <InventoryReport /> },
        { path: "reports/payments-report", element: <PaymentReport /> },
        { path: "reports/shipping-report", element: <ShippingReport /> },
        { path: "reports/campaign-report", element: <CampaignReport /> },
        { path: "reports/marketing-report", element: <MarketingReport /> },
        { path: "reports/warranty-report", element: <GenericReportPage /> },
        { path: "reports/support-report", element: <SupportReport /> },
        { path: "reports/customers", element: <CustomerReport /> }
      ]
    },
    {
      path: "/seller",
      element: (
        <ProtectedRoute>
          <Layout onLogout={handleLogout} />
        </ProtectedRoute>
      ),
      children: [
        { path: "dashboard", element: <DashboardPage /> },
        { path: "profile", element: <Profile /> },
        { path: "productmanagement", element: <Productmanagement /> },
        { path: "productmanagement/add", element: <AddProduct /> },
        { path: "productmanagement/edit/:productId", element: <EditProduct /> },
        { path: "productmanagement/view/:productId", element: <ViewProduct /> },
        { path: "variationgroups", element: <VariationGroups /> },
        { path: "productrequestlist", element: <ProductRequestList /> },
        { path: "categories", element: <Categories /> },
        { path: "categorycluster", element: <CategoryCluster /> },
        { path: "inventorymanagement", element: <Inventorymanagement /> },
        { path: "ordermanagement", element: <Ordermanagement /> },
        { path: "ordermanagement/:orderId", element: <Ordermanagement /> },
        { path: "warehouse", element: <Warehouse /> },
        { path: "activitylog", element: <ActivityLog /> },
        { path: "loginlogs", element: <LoginLogs /> },
        { path: "couponsmanagement", element: <Couponsmanagement /> },
        { path: "couponsmanagement/:couponId", element: <Couponsmanagement /> },
        { path: "settings", element: <Settings /> },
        { path: "rewards", element: <Rewards /> },
        { path: "apppolicy", element: <AppPolicy /> },
        { path: "faqs", element: <FAQs /> },
        { path: "notification", element: <Notification /> },
        { path: "sellerpayout", element: <SellerPayout /> },
        { path: "onlineorders", element: <OnlineOrders /> },
        { path: "onlineorders/:requestId", element: <OnlineOrders /> }
      ]
    },
    { path: "*", element: <NotFound /> }
  ]; // Top-level catch-all
  return routes;
}
